import React from 'react'

import { ShadowRoot } from './ShadowRoot';

import CollapsibleList from '../components/CollapsibleList';

import { getImageUrl, Sizes } from './blocks/editable/Img'

import ShareModal from '../components/modal/ShareModal'
import BadgeBlock from '../components/BadgeBlock';

import General from '../utils/General'
import Currency from '../utils/Currency'
import Notify from '../utils/Notify'
import Cart from '../utils/Cart'
import Event from "../utils/Event";


export default class Product extends React.Component {
  constructor(props){
    super(props)

    this.SECTION_RENDERERS = {
      product_image: '_renderProductMedia',
      description: '_renderProductDescription',
      metafields: '_renderMetaFields',
      title: '_renderProductName',
      price: '_renderProductPrice',
      variants: '_renderProductVariants',
      custom_message_options: '_renderCustomMessage',
      subscribe_save: '_renderSubScribeSave',
      quantity_cart: '_renderQuantityAndButtons',
      share_product: '_renderShareSection'
    };

    for (let i = 1; i <= 9; i++) {
      this.SECTION_RENDERERS[`storefront_detail_${i}`] = `_renderStorefrontDetail${i}`;
      this[`_renderStorefrontDetail${i}`] = () => this._renderDetail(i);
    }

    // key is incremented as the slider js functions
    // overwrite the html so we want to refresh it
    // as React is out of sync when
    // adding/editing/deleting the images
    this.state = {
      key: 0,
      loading: true,
      quantity: 1,
      customMessage: [],
      editable: props.editable,
      website: window.CURRENT_WEBSITE,
      options: [],
      product: props.product,
      variant: props.variant,
      variantOptions: props.variantOptions,
      customMessageOptions: props.customMessageOptions,
      subscribeAndSaveProduct: props.subscribeAndSaveProduct,
      subscribeAndSaveVariantOptions: props.subscribeAndSaveVariantOptions,
      subscribeAndSaveSettings: props.subscribeAndSaveSettings,
      extra: props.extra,
      purchaseOption: "single",
      frequency: null,
      evenColumnWidth: props.evenColumnWidth,
      layoutOrder: props.layoutOrder,
    }

    this.quantityInput = React.createRef()
  }

  componentDidMount() {
    this._setup()
    Event.on('WEBSITE_UPDATED', () => {
      this.setState({
        website: window.CURRENT_WEBSITE
      })
    });
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  componentWillUnmount(){
    Event.off('WEBSITE_UPDATED');
  }

  _setup(){

  }

  _renderLayoutSection(key) {
    const rendererName = this.SECTION_RENDERERS[key];
    if (!rendererName) {
      return null;
    }
    if (typeof this[rendererName] === 'function') {
      const output = this[rendererName]();
      return output === 'HIDE' ? null : output;
    }
    return null;
  }

  _renderColumnSections(position, layoutOrder) {
    return layoutOrder
      .filter(section => section.position === position)
      .map(section => (
        <React.Fragment key={section.key}>
          {this._renderLayoutSection(section.key)}
        </React.Fragment>
      ));
  }

  _handleAddToCart(){
    let {
      variant,
      frequency,
      product,
      purchaseOption,
      subscribeAndSaveProduct,
      quantity,
      customMessage,
      variantOptions,
      customMessageOptions
    } = this.state

    if(variant.length !== Object.entries(variantOptions).length){
      Notify.error("Please select all product options")
      return
    }

    if(customMessage.length !== customMessageOptions.length){
      Notify.error("Please fill out all options")
      return
    }

    if(product.billingCycleType === "ONE_TIME" && product.recurringProductId){
      if(purchaseOption === "recurring" && !frequency && product.subscriptionOptions){
        Notify.error("Please select your desired frequency")
        return
      }
    }

    if(purchaseOption === "single"){
      frequency = null
    }

    quantity = parseInt(this.quantityInput.current.value)
    variant = Cart.getVariant(product, variant)

    let cartProduct = product
    if(purchaseOption === "recurring" && product.recurringProductId){
      cartProduct = {...subscribeAndSaveProduct, hasSubscriptionOptions: !!product.subscriptionOptions}
    }

    this.props.onAddToCartPressed(cartProduct, variant, customMessage, quantity, frequency)

    this.setState({
      purchaseOption: "single",
      variant: Cart.selectDefaultVariant(product),
      customMessage: [],
      quantity: 1,
    })
  }

  _renderPrice(product, variant){
    let{
      variantOptions
    } = this.state

    const currency = window.CURRENT_CAMPAIGN?.currencySymbol
    let availableOptionsNo = Object.entries(variantOptions).length

    let price = product.cycle1_price
    let compareAtPrice = product.compareAtPrice
    if((availableOptionsNo > 0) && (variant.length === availableOptionsNo)){
      variant = Cart.getVariant(product, variant)
      if(variant && variant.price){
        price = variant.price
        compareAtPrice = variant.compareAtPrice
      }
    }

    if(product.on_sale){
      return (
        <>
          <span className="h4 type--strikethrough m-0 pr-1">{ Currency.toFormat(price) }</span>
          <span className="h4 m-0 pr-2">{ Currency.toFormat(price) }</span>
        </>
      )
    }

    return (
      <>
        <span className="h4 m-0 pr-2">Price:</span>
        {compareAtPrice > 0 && <span className="h4 type--strikethrough m-0 pr-1">{ Currency.toFormat(compareAtPrice) }</span>}
        <span className="h4 m-0">{ Currency.toFormat(price) }</span>
      </>
    )
  }

  _renderProductVariants(){
    let {
      product,
      variantOptions,
      variant,
      extra
    } = this.state
    const entries = Object.entries(variantOptions)
    const entriesLength = entries.length
    const selectedTileStyle = extra?.display_variant_tile_price && ["btn_horizontal", "btn_vertical"].includes(extra?.[`variant${entriesLength}_style`] || 'btn_horizontal');
    const imagePosition = extra?.img_tile_position || "right"
    const imageOnlyPosition = imagePosition === "img-only"
    const imageOnlyAspectRatio = extra?.img_only_aspect_ratio || ""
    const leftOrRightPosition = ["left", "right"].includes(imagePosition)
    return entries.map((key, index) => {
      const isColor = key[0].toLowerCase() === 'color'
      const showVariantPriceOnTile = selectedTileStyle && !isColor && ((index + 1) === entriesLength)
      const variantPriceInfo = showVariantPriceOnTile ? Cart.getLastVariantPriceInfo(product, variant, index + 1) : {}
      const variantImageTile = !isColor && (extra?.[`variant${index + 1}_style`] || "btn_horizontal") === "img_tile"
      const variantImages = variantImageTile && Cart.getProductImagesByVariantNameNumber(product, index + 1, variant)
      const variantImageObj = {
        variantImages,
        leftOrRightPosition,
        imagePosition,
        variantImageTile,
        imageOnlyAspectRatio,
        imageOnlyPosition
      }
      return this._renderVariant(key, index, isColor, variantImageObj, showVariantPriceOnTile, variantPriceInfo)
    })
  }

  _renderVariantTilePrices(variantPriceDetails, oneValidCompareAtPrices){
    const currency = window.CURRENT_CAMPAIGN?.currencySymbol || ""
    const campareAtPrice = Number(variantPriceDetails.compareAtPrice || 0)
    const price = Number(variantPriceDetails.price || 0)
    const validCompareAtPrice = campareAtPrice && campareAtPrice > price
    const savings = validCompareAtPrice ? (((campareAtPrice - price)/campareAtPrice) * 100).toFixed(0) + "%" : null
    return (
      <div className={`variant-tile-price-block ${oneValidCompareAtPrices ? '' : 'variant-tile-price-block-height-auto'}`}>
        <div className='variant-tile-price-container'>
          {validCompareAtPrice > 0 ? <div className='variant-tile-compare-price type--strikethrough'>{ Currency.toFormat(campareAtPrice) }</div> : null}
          <div className='variant-tile-price'>{ Currency.toFormat(price) }</div>
        </div>
        {savings && <div className='variant-tile-savings'>
          <span>Save {savings}</span>
        </div>}
      </div>
    )
  }

  _renderVariant(key, index, isColor, variantImageObj, showVariantPriceOnTile, variantPriceInfo){
    let {
      extra,
      variant,
      variantOptions
    } = this.state

    if(isColor && !variantOptions.Color){
      return
    }

    let colorStyle = extra?.color_picker_style || "square"

    let variantKey = `variant${index+1}_style`
    let variantStyle = extra[variantKey] || "btn_horizontal"

    const title = isColor ? 'Color' : key[0];
    const options = isColor ? variantOptions.Color : key[1];
    const selectType = isColor ? colorStyle : variantStyle;
    const {
      variantImages,
      leftOrRightPosition,
      imagePosition,
      variantImageTile,
      imageOnlyAspectRatio,
      imageOnlyPosition
    } = variantImageObj
    return (
      <div
        className={`${isColor ? 'color-swatches' : 'sizes'} my-28px`}
      >
        <h4 className="mb-2">{title}</h4>
        {
          selectType === 'dropdown' ?
            <div className="input-select">
              <select
                value={variant[index]}
                onChange={this.handleVariantChange(index, isColor, key)}
              >
                <option>Select {title}</option>
                {options.map((option, optionIndex) => {
                  return (
                    <option key={optionIndex} value={option}>
                      {option}
                    </option>
                  )
                })}
              </select>
            </div>
          :
            <div className={`items ${selectType}`}>
              {options.map((option, optionIndex) => {
                return (
                  <div
                    key={optionIndex}
                    className={`item input-radio input-radio--innerlabel ${variantImageTile ? `product-variant-tile-label-container product-variant-tile-label-container-${imagePosition}` : ""}`}
                    title={option}
                  >
                    <input
                      type="radio"
                      name={isColor ? 'colors' : key[0]}
                      value={option}
                      id={`${isColor ? 'color' : key[0]}-${optionIndex}`}
                      checked={variant[index] === option}
                      onChange={this.handleVariantChange(index, isColor, key)}
                    />
                    {
                      variantImageTile ?
                        <label htmlFor={`${key[0]}-${optionIndex}`} className={`btn ${variantImageTile ? `product-variant-tile-label product-variant-tile-label-${imagePosition} ${!imageOnlyPosition && !variantImages[option] ? "product-variant-tile-has-no-img" : ""}` : ""}`}>
                          <div className={`product-variant-tile-block product-variant-tile-img-position-${imagePosition}`}>
                            {!imageOnlyPosition && <div className='product-variant-tile-text-container'>
                              {leftOrRightPosition && option?.length > 18 ? option.substring(0, 18) + "..." : option}
                            </div>}
                            <div className={`product-variant-tile-image-container ${imageOnlyPosition && imageOnlyAspectRatio ? `${imageOnlyAspectRatio} product-variant-tile-image-width` : ""}`}>
                              {
                                (imageOnlyPosition ? variantImages[option] : true) && <img className={`product-variant-tile-image ${imageOnlyPosition && imageOnlyAspectRatio ? "product-variant-tile-image-aspect-ratio" : ""}`} src={variantImages[option]} alt={option} />}
                              {
                                imageOnlyPosition && !variantImages[option] && (<div className='product-variant-tile-no-image-text-container'>{ option?.length > 18 ? option.substring(0, 18) + "..." : option }</div>)
                              }
                            </div>
                          </div>
                        </label>
                      :
                      <>
                        <label htmlFor={`${isColor ? 'color' : key[0]}-${optionIndex}`} className={isColor ? '' : `btn ${showVariantPriceOnTile ? 'variant-tile-price-label' : ''}`}>
                          {isColor ? <span className='color' style={{ backgroundColor: option }}></span> : option}
                          {isColor ? <span className='name'>{option}</span> : null}
                          {showVariantPriceOnTile && this._renderVariantTilePrices(variantPriceInfo?.pricesObj?.[option], variantPriceInfo?.oneValidCompareAtPrices)}
                        </label>
                      </>
                    }
                  </div>
                )
              })}
            </div>
        }
      </div>
    )
  }

  _renderCustomMessage(){
    let{
      product,
      customMessage,
      customMessageOptions
    } = this.state

    if(customMessageOptions.length < 1) return null

    return customMessageOptions.map((customMessageOption, index) => {
      return (
        <div
          className={`my-28px`}
        >
          <h4 className="mb-2">{customMessageOption}</h4>
          <div>
            <input
              type="text"
              placeholder={customMessageOption}
              value={customMessage[index]?.split(":")[1] || ""}
              onChange={e => {
                customMessage[index] = `${customMessageOption}:${e.target.value}`
                this.setState({customMessage})
              }}
            />
          </div>
        </div>
      )
    })
  }

  handleVariantChange(index, isColor, key) {
    return (e) => {
      const selectedOptionName = e.target.value;
      const variant = [...this.state.variant];

      if (selectedOptionName === key[0]) {
        variant[index] = null;
      } else {
        variant[index] = selectedOptionName;
      }

      this.setState({ variant }, () => {
        setTimeout(() => {
          General.updateSlides();
          General.updateLazyBackgroundImages();
        }, 50);
      });
    };
  }

  _renderSubScribeSave(){
    let {
      frequency,
      product,
      variant,
      variantOptions,
      purchaseOption,
      subscribeAndSaveProduct,
      subscribeAndSaveVariantOptions,
      subscribeAndSaveSettings
    } = this.state

    let subscribeAndSaveVariant = General.clone(variant)

    const hasSubscriptionOptions = !!product.subscriptionOptions;
    const hasValidSubscribeAndSave = !!(subscribeAndSaveProduct && subscribeAndSaveProduct.cycle1_billDelay);

    if (!hasSubscriptionOptions && !hasValidSubscribeAndSave) {
      return null;
    }

    let availableOptionsNo = Object.entries(variantOptions).length

    let price = product.cycle1_price
    if((availableOptionsNo > 0) && (variant.length === availableOptionsNo)){
      variant = Cart.getVariant(product, variant)
      if(variant && variant.price){
        price = variant.price
      }
    }

    let subscribeAndSaveFrequency = null
    let readOnly = false

    if(product.subscriptionOptions){
      subscribeAndSaveFrequency = product.subscriptionOptions?.split(",").map(option => {
        return {
          value: option,
          label: option
        }
      })

      subscribeAndSaveFrequency.unshift({
        value: null,
        label: "Select Frequency"
      })
    }else if(subscribeAndSaveProduct.cycle1_billDelay){
      readOnly = true
      subscribeAndSaveFrequency = [{
        value: subscribeAndSaveProduct.cycle1_billDelay,
        label: `${subscribeAndSaveProduct.cycle1_billDelay} Days`
      }]
    }

    let subscribeAndSaveAvailableOptionsNo = Object.entries(subscribeAndSaveVariantOptions).length
    let subscribeAndSavePrice = subscribeAndSaveProduct.cycle1_price
    if((subscribeAndSaveAvailableOptionsNo > 0) && (subscribeAndSaveVariant.length === subscribeAndSaveAvailableOptionsNo)){
      subscribeAndSaveVariant = Cart.getVariant(subscribeAndSaveProduct, subscribeAndSaveVariant)
      if(subscribeAndSaveVariant && subscribeAndSaveVariant.price){
        subscribeAndSavePrice = subscribeAndSaveVariant.price
      }
    }

    const exchangedPrice = Currency.toConvert(price)

    const discount = Math.abs( (exchangedPrice - Currency.toConvert(subscribeAndSavePrice)) / (exchangedPrice) ) * 100

    let ITEMS = [
      {
        value: "single",
        label: "One Time Purchase",
        price: Currency.toFormat(price)
      },
      {
        value: "recurring",
        label: "Subscribe and Save",
        price: Currency.toFormat(subscribeAndSavePrice),
        discount: parseInt(discount),
        frequency: subscribeAndSaveFrequency
      }
    ]

    return (
      <div className='subscribe-save my-28px'>
        <h4 class="mb-2">Purchase Options</h4>
        {
          ITEMS.map((item,index) => {
            const isSelected = item.value === purchaseOption;
            const iconClass = item.value === 'recurring' ? subscribeAndSaveSettings.subscribeIcon : subscribeAndSaveSettings.oneTimeIcon;
            const iconColor = isSelected ? subscribeAndSaveSettings.selectedTextColor : subscribeAndSaveSettings.textColor;

            const labelStyle = {
              border: `1px solid ${isSelected ? subscribeAndSaveSettings.selectedBorderColor : subscribeAndSaveSettings.borderColor}`,
              borderRadius: subscribeAndSaveSettings.borderStyle,
              backgroundColor: isSelected ? subscribeAndSaveSettings.selectedBackgroundColor : subscribeAndSaveSettings.backgroundColor,
            };

            const textStyle = {
              color: isSelected ? subscribeAndSaveSettings.selectedTextColor : subscribeAndSaveSettings.textColor,
            };

            const oneTimePrice = parseFloat(price);
            const recurringPrice = parseFloat(subscribeAndSavePrice);

            let discountText = '';
            if (!isNaN(oneTimePrice) && !isNaN(recurringPrice) && recurringPrice < oneTimePrice && item.value === 'recurring') {
              const priceDiff = oneTimePrice - recurringPrice;
              const percent = Math.round((priceDiff / oneTimePrice) * 100);

              switch (subscribeAndSaveSettings.discountFormat) {
                case 'price':
                  discountText = `save ${Currency.toFormat(priceDiff)}`;
                  break;
                case 'percent':
                  discountText = `save ${percent}%`;
                  break;
                case 'both':
                  discountText = `save ${Currency.toFormat(priceDiff)} (${percent}%)`;
                  break;
              }
            }
            return (
              <div class="item input-radio input-radio--innerlabel" key={item.value}>
                <input
                  type="radio"
                  name="subscribe"
                  value={item.value}
                  checked={isSelected}
                  onChange={(e) => {
                    let value = e.target.value
                    let update = { purchaseOption: value }
                    if (value === "recurring" && !product.subscriptionOptions && subscribeAndSaveProduct?.cycle1_billDelay) {
                      update.frequency = `${subscribeAndSaveProduct.cycle1_billDelay} Days`
                    }
                    this.setState(update)
                  }}
                />
                <label style={labelStyle} for="radio-1">
                  <div className='t-sec'>
                    <div className={`dot ${subscribeAndSaveSettings.useCustomIcon ? 'icon-mode' : ''}`}>
                      {iconClass ?
                        (<i className={iconClass} style={{ fontSize: 16, color: iconColor }} />)
                        : (
                          <span />
                        )}
                    </div>
                    <div className='name' style={textStyle}>
                      {item.label}
                      {item.value === 'recurring' && discountText && (
                        <div className="discount">{discountText}</div>
                      )}
                    </div>
                    <div className='price' style={textStyle}>
                      {item.price}
                    </div>
                  </div>

                  {(item.points || item.frequency) &&
                    <div className='b-sec'>
                      <div className='frequency'>
                        <div className='name' style={textStyle}>Frequency:</div>
                        <div className="input-select">
                          <select
                            disabled={readOnly}
                            onChange={e => {
                              frequency = e.target.value
                              this.setState({frequency})
                            }}
                          >
                            {
                              item.frequency?.map(option => (
                                <option key={option.value} value={option.value}>{option.label}</option>
                              ))
                            }
                          </select>
                        </div>
                      </div>
                    </div>
                  }
                </label>
              </div>
            )
          })
        }
      </div>
    )
  }

  _renderSlides(){
    let {
      key,
      variant,
      product,
    } = this.state

    if(product == null){
       return null
    }

    let images = [{original: product.imageUrl}]

    if(product.imageUrls){
      images = product.imageUrls.map(imageUrl => {
        return {original: imageUrl}
      })
    }

    let selectedVariant = Cart.getVariant(product, variant)
    if(selectedVariant?.imageUrl){
      images.unshift({original: selectedVariant.imageUrl})
    }

    return (
      <ul key={images.length} className="slides">
        {
          images.map((image, index) => {
            return (
              <li
                className="lazy-background"
                key={index}
                style={{ backgroundImage: "url(" + getImageUrl(image, "product-page") + ")" }}
                priority={this.props.index}
              ></li>
            )
          })
        }
      </ul>
    )
  }

  _renderTabTitles(infos){
    return infos.map((info, index) => {
      let className = index === 0 ? "active" : ""
      let id = "textInfo_"+index
      return (
        <li key={id} className={className}>
          <div className="tab__title">
              <span>{ info.name }</span>
          </div>
        </li>
      )
    })
  }

  _renderTabContent(infos){
    return infos.map((info, index) => {
      let className = index === 0 ? "active" : ""
      let id = "textInfo_"+index
      return (
        <li key={ id } id={ id } className={className}>
          <div className="tab__content">
              {
                info.valueType === "RICH_TEXT" ? <ShadowRoot><div dangerouslySetInnerHTML={{ __html: info.value }} ></div></ShadowRoot> : <p className="pre">{ info.value }</p>
              }
          </div>
        </li>
      )
    })
  }

  _renderCollapsibleList(){
    const { product, extra } = this.state
    const metaFields = Cart.getProductMetaData(product)
    if(!metaFields.length){
      return
    }
    const openIcon = extra?.collapsible_list_open_icon
    const closeIcon = extra?.collapsible_list_close_icon
    const autoToggle = extra?.collapsible_list_toggle
    return <>
      <section className="pt-5 p-0">
        <div className="container">
          <div className="row justify-content-center">
              <div className="col-md-12 p-0">
                <CollapsibleList data={metaFields} openIcon={openIcon} closeIcon={closeIcon} autoToggle={typeof autoToggle === "boolean" ? autoToggle : true} />
              </div>
          </div>
        </div>
      </section>
    </>
  }

  _renderTabs(){
    let {
      product,
      website,
      editable
    } = this.state

    const metaFields = Cart.getProductMetaData(product)

    if(!metaFields.length){
      return
    }

    return (
      <>
        {/* starts, Product Tabs */}
        <section className="pt-5 p-0">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12 p-0">
                <div id="product-tabs" className="tabs-container tabs--folder">
                  <>
                    <ul className="tabs">
                      { this._renderTabTitles(metaFields)}
                    </ul>
                    <ul className="tabs-content">
                      { this._renderTabContent(metaFields)}
                    </ul>
                  </>
                </div>
                { General.renderTabStyle({
                    secondary_color: website.primary_color,
                  }, "product-tabs")
                }
              </div>
            </div>
          </div>
        </section>
        {editable && window.$ && window?.mr?.tabs?.documentReady(window.$)}
        {/* } end, Product Tabs  */}
      </>
    )
  }

  _renderQuantityAndButtons() {
    const {quantity} = this.state;
    const checkoutType = window.CURRENT_WEBSITE.checkout_type;
    const isBoth = checkoutType === "instantAndCart" || checkoutType === "instantAndBuy";
    const cartButtonText = checkoutType === "instant" ? "Buy Now" : "Add To Cart";

    return (
      <>
        <div className='row quan-cart my-38px mx-0'>
          <div className='col-md-4 pl-0'>
            <div className="input-number">
              <input
                ref={this.quantityInput}
                type="number"
                name="quantity"
                value={quantity}
                min="1"
                onChange={e => this.setState({quantity: parseInt(e.target.value)})}
              />
              <div className="input-number__controls">
                <span className="input-number__increase" onClick={() => this.setState({quantity: quantity + 1})}>
                  <i className="stack-up-open"></i>
                </span>
                <span className="input-number__decrease"
                      onClick={() => this.setState({quantity: Math.max(1, quantity - 1)})}>
                  <i className="stack-down-open"></i>
                </span>
              </div>
            </div>
          </div>
          <div className='col-md-8 p-md-0'>
            <div className="sticky-buttons-wrapper d-flex flex-row gap-2">
              {isBoth ? (
                <>
                  <a className="btn btn--primary sticky-btn" onClick={() => {
                    window.CURRENT_WEBSITE.checkout_type = "instantAndCart";
                    this._handleAddToCart();
                  }}>
                    <span className="btn__text">Add To Cart</span>
                  </a>
                  <a className="btn btn--secondary sticky-btn" onClick={() => {
                    window.CURRENT_WEBSITE.checkout_type = "instantAndBuy";
                    this._handleAddToCart();
                  }}>
                    <span className="btn__text">Buy Now</span>
                  </a>
                </>
              ) : (
                <a className="btn btn--primary w-100" onClick={() => this._handleAddToCart()}>
                  <span className="btn__text">{cartButtonText}</span>
                </a>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }

  _renderProductMedia() {
    const {extra, product} = this.state;
    return (
      <>
        <div className='position-relative'>
          <div
            className="slider-product-main slider border--round boxed--border"
            data-paging="true"
            data-arrows="true"
            data-autoplay={extra?.autoplay_carousel_toggle ? "true" : "false"}
          >
            {this._renderSlides()}
          </div>
          <BadgeBlock product={product}/>
        </div>
        <div
          className="slider-product-nav slider border--round boxed--border"
          data-asNavFor=".slider-product-main .slides"
          data-asNavTrue="true"
        >
          {this._renderSlides()}
        </div>
      </>
    );
  }

  _renderProductDescription() {
    const {product} = this.state;
    if (!product.productDescription) {
      return null;
    }

    return (
      <section className="switchable p-0">
        <div className="container">
          <div className="row">
            <div className="col-md-12 p-0">
              <h2>Product Description</h2>
              <div className="lead pre" dangerouslySetInnerHTML={{__html: product.productDescription}}/>
            </div>
          </div>
        </div>
      </section>
    );
  }

  _renderMetaFields() {
    const {extra} = this.state;
    return extra?.meta_field_type === "collapsible-list"
      ? this._renderCollapsibleList()
      : this._renderTabs();
  }

  _renderShareSection() {
    const {showShareModal} = this.state;
    return (
      <>
        <span className="link-share d-flex justify-content-center align-items-center">
          <span className="r-box material-icons bg-c-primary">share</span>
          <a href='javascript:void(0)' className='text-uppercase type--underline link--primary'
             onClick={() => this.setState({showShareModal: true})}>
            Share this Product
          </a>
        </span>
        <ShareModal
          show={showShareModal}
          title="Share This Product"
          message="Copy the link below to share this product"
          shareTitle="Checkout This Product"
          url={window.location}
          onHide={() => this.setState({showShareModal: false})}
          onAdded={() => this.setState({showShareModal: false})}
        />
      </>
    );
  }

  _renderProductName() {
    const {product} = this.state;
    return (
      <h2 className='fs-md-30'>{product.productName}</h2>
    );
  }

  _renderProductPrice() {
    const {product, variant} = this.state;
    return (
      <div className="text-block d-flex align-items-center mb-0">
        {this._renderPrice(product, variant)}
        {product.on_sale && (
          <span className="label position-static product-sale-price">Sale</span>
        )}
      </div>
    );
  }

  _renderDetail(index) {
    const metaFields = this.state.product?.metaFields || [];

    const field = metaFields.find(f =>
      typeof f.name === "string" &&
      f.name.toLowerCase().replace(/\s+/g, '') === `storefront-detail-${index}`
    );

    if (!field || !field.value || field.value.toLowerCase() === 'show') {
      return null;
    }

    return (
      <div
        className={`storefront-detail storefront-detail-${index}`}
        key={`meta-${index}`}
        dangerouslySetInnerHTML={{__html: field.value}}
      />
    );
  }


  render(){
    let {
      product,
      website,
      variant,
      quantity,
      funnelJson,
      indexLoaded,
      campaignJson,
      showShareModal,
      variantOptions,
      loading,
      extra,
      evenColumnWidth,
      layoutOrder
    } = this.state

    if(!product || !variantOptions){
      return null
    }

    return (
      <>
        <div className="row justify-content-around">
          {/* starts, column right, sticky sidebar  */}
          <div className={`col-md-${evenColumnWidth ? 6 : 5}`}>
            <div className="sidebar__inner">
              {this._renderColumnSections("right", layoutOrder)}
            </div>
          </div>
          {/* end, column right, sticky sidebar  */}

          {/* starts, column left  */}
          <div className={`col-md-${evenColumnWidth ? 6 : 7} ${extra?.sticky_left_column ? "sticky-left-column" : ""}`}>
            {this._renderColumnSections("left", layoutOrder)}
          </div>
        </div>
        {/* end, column left  */}
        <div className="row justify-content-around">
          {/* starts, bottom row  */}
          <div className="col-12 mb-4">
            {this._renderColumnSections("row", layoutOrder)}
          </div>
          {/* end, bottom row  */}
        </div>
      </>
    )
  }
}
